import React from 'react'
import 'base-ui/dist/index.css'
import './styles/main.css'
import { HashRouter as Router, Switch, Route } from 'react-router-dom'

import Nav from './components/Nav/Nav'
import SideNav from './components/SideNav/SideNav'
import Brand from './pages/Brand'
import Principles from './pages/Principles'
import Form from './pages/Form'
import Typography from './pages/Typography'
import Display from './pages/Display'
import Assets from './pages/Assets'
import Feedback from './pages/Feedback'
import Color from './pages/Color'
import Navigation from './pages/Navigation'
import Overlay from './pages/Overlay'
import Spacing from './pages/Spacing'

const App = () => {
  return (
    <Router>
      <>
        <Nav/>
        <div className="max-w-screen-2xl mx-auto">
          <div className="gap-4 flex">
            <SideNav />
            <div className='px-5 overflow-y-auto pt-32 w-3/4'>
              <Switch>
                <Route exact path='/' render={Principles} />
                <Route path='/brand' render={Brand} />
                <Route path='/principles' render={Principles} />
                
                {/* FOOUNDATIONS */}
                <Route path='/typography' render={Typography} />
                <Route path='/color' render={Color} />
                {/* <Route path='/Form and Dimension' render={FormAndDimension} /> */}
                <Route path='/Spacing' render={Spacing} />
                <Route path='/assets' render={Assets} />

                {/* COMPONENTS */}
                {/* <Route path='/layouts' render={Layouts} /> */}
                <Route path='/form' render={Form} />
                <Route path='/navigation' render={Navigation} />
                {/* <Route path='/areas' render={Areas} /> */}
                <Route path='/feedback' render={Feedback} />
                <Route path='/display' render={Display} />
                <Route path='/overlay' render={Overlay} />
                
              </Switch>
            </div>
          </div>
        </div>
      </>
    </Router>
  )
}

export default App
